module.exports = __webpack_public_path__ + "img/img2.cd4a728b.png";